const routes = [
  {
    index: true,
    label: 'Ray Liu',
    path: '/',
  },
  {
    label: 'Projects',
    path: '/projects',
  },
  {
    label: 'Resume',
    path: '/resume',
  },
  {
    label: 'About',
    path: '/about',
  },
  // {
  //   label: 'Stats',
  //   path: '/stats',
  // },
  // {
  //   label: 'Contact',
  //   path: '/contact',
  // },
];

export default routes;
